export const LOAD_CHATROOMS = "LOAD_CHATROOMS";
export const LOAD_CHATROOMS_SUCCESS = "LOAD_CHATROOMS_SUCCESS";
export const LOAD_CHATROOMS_ERROR = "LOAD_CHATROOMS_ERROR";
export const LOAD_CHATROOMS_BY_ID = "LOAD_CHATROOMS_BY_ID";
export const UPDATE_CHATROOMS_DELETE = "UPDATE_CHATROOMS_DELETE";
